<template>
    <div class="locale-changer">
        <div class="nav-item dropdown">
            <a
                href="#"
                role="button"
                id="navbarDropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-toggle="dropdown"
                class="nav-link dropdown-toggle"
            >
                <span :style="cssVars">
                    <i class="fas fa-globe"></i>
                    {{ currentLocale }}
                </span>
            </a>

            <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="navbarDropdown"
            >
                <a
                    class="dropdown-item"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-for="(langname, langcode) in langs"
                    :key="langcode"
                    v-on:click="changeLocale(langcode)"
                >
                    {{ langname }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "../eventbus";
export default {
    data() {
        return {
            langs: {
                es: "Español",
                en: "English"
            }
        };
    },
    props: {
        textColor: {
            type: String,
            default: "black"
        }
    },
    computed: {
        currentLocale() {
            return this.langs[this.$i18n.locale];
        },
        cssVars() {
            return {
                "--color": this.textColor
            };
        }
    },
    methods: {
        changeLocale(locale) {
            this.$i18n.locale = locale;
            EventBus.emit("locale.changed", locale);
        }
    }
};
</script>
<style scoped>
span {
    color: var(--color);
}
</style>
